module.exports = __webpack_public_path__ + "img/dgd.017d2acb.svg";